import { action, payload } from 'ts-action'
import { IProperty } from '@network/models/property.model'
import { IError, IPayload } from '@network/models/global.model'

export const GetProperty = action('GetProperty', payload<IPayload<IProperty>>())

export const PropertyErrors = action('PropertyErrors', payload<IError>())

export const PropertyFetching = action('PropertyFetching', payload<boolean>())

export const ClearProperty = action('ClearProperty')
